import { render, staticRenderFns } from "./PremiumDiscounts.vue?vue&type=template&id=267c4e28"
import script from "./PremiumDiscounts.vue?vue&type=script&lang=js"
export * from "./PremiumDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports